import {CameraResolution} from '@/types/camera-type';

export class CameraToTicketCategoryClass {
  constructor(
    public cameraId: string,
    public ticketCategoryId: string,
    public resolution: string
  ) {
  }
}
